/* eslint-disable */
export default {
  _click: 'click',
  _coin8: 'coin8',
  _crash: 'crash',
  _hoho: 'hoho',
  _jump2: 'jump2',
  _lg_snow: 'lg_snow',
  _pixel_bells_fast: 'pixel_bells_fast',
  _pixel_bells: 'pixel_bells',
  _sm_snow: 'sm_snow',
  _speed_boost: 'speed_boost',
}